const state = {
  showSettings: false,
  fixedHeader: false,
  sidebarLogo: true,
  limitllMoney: 100000
};
const mutations = {
  CHANGE_SETTING: (state, {
    key,
    value
  }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};
const actions = {
  changeSetting({
    commit
  }, data) {
    commit('CHANGE_SETTING', data);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};